// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.CreateDashboardFolderModal {
  display: flex;
  flex-direction: column;
  height: 650px;
  width: 500px;
  padding: 32px 0px;
}
.CreateDashboardFolderModal h3 {
  font-weight: 600;
  margin-bottom: 24px;
  padding: 0px 32px;
}
.CreateDashboardFolderModal [class^=dist_inputContainer] {
  margin-bottom: 32px;
  padding: 0px 32px;
}
.CreateDashboardFolderModal .listLabel {
  font-size: 12px;
  color: var(--color_neutral_500);
  padding: 0px 32px;
}
.CreateDashboardFolderModal .dashboardList {
  position: relative;
  height: 388px;
  list-style: none;
  padding: 0px;
  margin: 0px 0px 32px;
  overflow-y: scroll;
}
.CreateDashboardFolderModal .dashboardList::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.CreateDashboardFolderModal .dashboardList::-webkit-scrollbar-track {
  background: transparent;
}
.CreateDashboardFolderModal .dashboardList::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.CreateDashboardFolderModal .dashboardList:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.CreateDashboardFolderModal .dashboardList::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.CreateDashboardFolderModal .dashboardList:after {
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);
  content: "";
  height: 20px;
  left: 0;
  bottom: 100px;
  position: fixed;
  width: calc(100% - 7px);
}
.CreateDashboardFolderModal [class^=dist_Loading] {
  margin-top: 8px !important;
}
.CreateDashboardFolderModal .buttonsSection {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0px 32px;
}
.CreateDashboardFolderModal [class^=dist_Checkbox-wrapper] {
  padding: 8px 32px;
}
.CreateDashboardFolderModal [class^=dist_Checkbox-wrapper]:hover {
  background-color: var(--color_primary_100);
}
.CreateDashboardFolderModal [class^=dist_Checkbox-wrapper] [class^=dist_checkbox-content] {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.CreateDashboardFolderModal [class^=dist_Checkbox-wrapper] .dashboardName {
  color: var(--color_neutral_800);
  font-size: 14px;
  font-weight: 700;
}
.CreateDashboardFolderModal [class^=dist_Checkbox-wrapper] .dashboardInfo {
  color: var(--color_neutral_500);
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/dashboard/create-dashboard-folder-modal/create-dashboard-folder-modal.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAeF;AAbE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AAeJ;AAZE;EACE,mBAAA;EACA,iBAAA;AAcJ;AAXE;EACE,eAAA;EACA,+BAAA;EACA,iBAAA;AAaJ;AAVE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AAYJ;AD9BE;EACE,UAAA;EACA,WAAA;ACgCJ;AD7BE;EACE,uBAAA;AC+BJ;AD5BE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;AC8BJ;AD1BI;EACE,oCApBS;ACgDf;ADxBE;EACE,oCAxBY;ACkDhB;AA1BE;EACE,sEAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AA4BJ;AAzBE;EACE,0BAAA;AA2BJ;AAxBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AA0BJ;AAvBE;EACE,iBAAA;AAyBJ;AAvBI;EACE,0CAAA;AAyBN;AAtBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AAwBN;AArBI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AAuBN;AApBI;EACE,+BAAA;EACA,eAAA;AAsBN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.CreateDashboardFolderModal {\n  display: flex;\n  flex-direction: column;\n  height: 650px;\n  width: 500px;\n  padding: 32px 0px;\n\n  h3 {\n    font-weight: 600;\n    margin-bottom: 24px;\n    padding: 0px 32px;\n  }\n\n  [class^='dist_inputContainer'] {\n    margin-bottom: 32px;\n    padding: 0px 32px;\n  }\n\n  .listLabel {\n    font-size: 12px;\n    color: var(--color_neutral_500);\n    padding: 0px 32px;\n  }\n\n  .dashboardList {\n    position: relative;\n    height: 388px;\n    list-style: none;\n    padding: 0px;\n    margin: 0px 0px 32px;\n    overflow-y: scroll;\n    @include scrollbar;\n  }\n\n  .dashboardList:after {\n    background: linear-gradient(180deg, hsla(0, 0%, 100%, 0) 16.67%, #fff);\n    content: '';\n    height: 20px;\n    left: 0;\n    bottom: 100px;\n    position: fixed;\n    width: calc(100% - 7px);\n  }\n\n  [class^='dist_Loading'] {\n    margin-top: 8px !important;\n  }\n\n  .buttonsSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    padding: 0px 32px;\n  }\n\n  [class^='dist_Checkbox-wrapper'] {\n    padding: 8px 32px;\n\n    &:hover {\n      background-color: var(--color_primary_100);\n    }\n\n    [class^='dist_checkbox-content'] {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      width: 100%;\n    }\n\n    .dashboardName {\n      color: var(--color_neutral_800);\n      font-size: 14px;\n      font-weight: 700;\n    }\n\n    .dashboardInfo {\n      color: var(--color_neutral_500);\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
